<div class="success-wrapper">
    <div class="container">
        <img class="img-100" src="assets/images/other-images/happy.png" alt="Happy icon">
        <div class="success-heading">
            <h2 class="headline font-secondary">Félicitations !</h2>
        </div>
        <div class="col-md-8 offset-md-2">
            <p class="sub-content">Votre profil structure a été créé avec succès.</p>
            <p class="sub-content">Vous pouvez désormais explorer les fonctionnalités de notre plateforme.</p>
        </div>
        <div>
            <a class="btn btn-primary-gradien btn-lg" routerLink="/">Retour à l'accueil</a>
        </div>
    </div>
</div>
